import { Injectable, NgZone } from '@angular/core';
import { ToastService } from './toast.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConnectionStatus, Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private statusSubject: BehaviorSubject<ConnectionStatus> = new BehaviorSubject<ConnectionStatus>({
    connected: true,
    connectionType: 'unknown'
  });

  public currentStatus$: Observable<ConnectionStatus> = this.statusSubject.asObservable();

  constructor(private toastService: ToastService, private zone: NgZone) {
    this.initializeNetworkListener();
  }

  private async initializeNetworkListener(): Promise<void> {
    const initialStatus = await Network.getStatus();
    this.handleStatus(initialStatus);
    this.statusSubject.next(initialStatus);

    Network.addListener('networkStatusChange', status => {
      this.handleStatus(status);

      this.zone.run(() => {
        this.statusSubject.next(status);
      });
    });
  }

  handleStatus(status: ConnectionStatus) {
    if (!status.connected) {
      this.toastService.show('warning', 'Sin conexión de Internet', 'middle');
    }
  }

  public async getCurrentStatus(): Promise<ConnectionStatus> {
    return Network.getStatus();
  }

  public async cleanup(): Promise<void> {
    await Network.removeAllListeners();
  }
}
